import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import Popover from '@mui/material/Popover';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import NotificationTabs from 'organisms/Notification/NotificationTabs';
import React from 'react';
import { useStore } from 'stores/store';

import s from './NotificationWrapper.module.scss';

const NotificationWrapper = ({ className }: { className?: string }) => {
  const store = useStore();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleClick = async (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    store.UIStore.setNotificationsActive(true);
  };

  const onClose = async () => {
    setAnchorEl(null);
    store.UIStore.setNotificationsActive(false);
  };

  const open = Boolean(anchorEl) && store.UIStore.isNotificationsActive;
  const id = open ? 'notifications-popover' : undefined;

  const count =
    store.NotificationStore.unreadDirectCount > 0
      ? store.NotificationStore.unreadDirectCount < 9
        ? store.NotificationStore.unreadDirectCount
        : '9+'
      : '';

  return (
    <div className={cn(s.NotificationWrapper, className)}>
      <Badge
        badgeContent={count || 0}
        sx={{
          '& .MuiBadge-badge': {
            color: '#fff',
            backgroundColor: 'text.primary'
          }
        }}
        invisible={!count}
      >
        <div className={s.NotificationWrapper__btn} onClick={handleClick}>
          <div className={s.NotificationWrapper__btnIconHolder}>
            <NotificationsIcon className={s.NotificationWrapper__btnIcon} color="inherit" />
          </div>
        </div>
      </Badge>
      <Popover
        id={id}
        disableScrollLock={true}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        TransitionProps={{ timeout: { enter: 0, exit: 0 } }}
      >
        <NotificationTabs />
      </Popover>
    </div>
  );
};

export default observer(NotificationWrapper);
